<template>
  <div class="bringins-content newShed">
    <div style="position: absolute; width: 100%; height: 100%">
      <div class="emission">
        <div
          class="emission-content"
          :class="{ 'emission-content-green': styleType == 'typeGreen', 'padding-class': (detailPopup.deviceType !== '电子围栏' && detailPopup.deviceType !== 'VDM150监测仪') }"
        >
          <div class="emission-title">区域详情</div>
          <!-- 详情区域 -->
          <div
            v-if="
              detailPopup.deviceType === '电子围栏' ||
              detailPopup.deviceType === 'VDM150监测仪'
            "
            class="emission-top"
          >
            <div class="emission-item">
              <span class="label">报警触发时间:</span>
              <span class="value" style="color: #4be0ff">{{
                lastVdm.collectionTime
              }}</span>
            </div>
            <div class="emission-item">
              <span class="label">污染监测值:</span>
              <span class="value" style="color: #ff7373">{{
                `${lastVdm.value ? lastVdm.value : 0}${
                  unitType ? unitType : "mg/m³"
                }`
              }}</span>
            </div>
            <div
              class="emission-item"
              v-if="detailPopup.deviceType === 'VDM150监测仪'"
            >
              <span class="label">告警阈值:</span>
              <span class="value" style="color: #f5a623">5mg</span>
            </div>
          </div>
          <!-- vdm 中部区域 -->
          <div
            v-if="detailPopup.deviceType !== '洗车台'"
            class="emission-middle"
          >
            <div
              v-if="detailPopup.deviceType === '电子围栏'"
              class="emission-left"
              @click="largeImg"
            >
              <div class="title">污染监测画面</div>
              <div class="content">
                <el-carousel height="350px" :autoplay="false" ref="carousel">
                  <el-carousel-item v-for="(item, i) in vdmImgList" :key="i">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.imgUrl"
                      :data-index="i"
                    >
                    </el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div class="emission-right">
              <div class="title">现场运行画面</div>
              <div class="content">
                <vdm-cvr :lastTime="curTime" :recodeDate="recodeDate" :nvrIp="nvrIp" :channelId="channelId"></vdm-cvr>
              </div>
            </div>
          </div>
          <!-- 洗车机中部区域 -->
          <div v-else-if="detailPopup.deviceType === '洗车台'" class="emission-middle">
            <div
              v-for="(item_, n) in vehicles"
              :key="n"
              class="emission-left"
            >
              <div class="title">洗车机</div>
              <div class="content">
                <el-carousel height="350px" :autoplay="false" :ref="'wash' + n">
                  <el-carousel-item v-for="(item, i) in vehiclesImg" :key="i">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.imgUrl"
                      :data-index="'wash'+i"
                    >
                    </el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div
              v-for="(item_, n) in warns"
              :key="n"
              class="emission-right"
            >
              <div class="title">违规抓拍</div>
              <div class="content">
                <el-carousel height="350px" :autoplay="false" :ref="'warn' + n">
                  <el-carousel-item v-for="(item, i) in warnImg[n]" :key="i">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.imgUrl"
                      :data-index="'warn'+i"
                    >
                    </el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <!-- vdm 雾炮底部chart -->
          <div
            v-if="detailPopup.deviceType !== '洗车台'"
            class="emission-bottom"
          >
            <div class="emission-date">
              <span>污染监测历史曲线</span>
              <el-form ref="form" :model="form" :inline="true">
                <el-form-item label="起止时间">
<!--                  <el-date-picker
                    v-model="dateRange"
                    type="datetimerange"
                    range-separator="至"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>-->
                  <DatePicker
                    init-width="420px"
                    :start-time-str="dateRange[0]"
                    :end-time-str="dateRange[1]"
                    @dateChange="changeTime"
                    :current-date-list="dateRange"
                    top-px="50px"
                    dateType="timerange"
                  >
                  </DatePicker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- vdm -->
            <div
              v-if="detailPopup.deviceType !== '雾炮'"
              ref="Echart"
              id="Echart"
              class="emission-chart"
            ></div>
            <!-- 雾炮 -->
            <div
              v-else-if="this.detailPopup.deviceType === '雾炮'"
              v-for="(item, i) in dusters"
              :key="i"
              class="emission-fog"
            >
              <div
                v-for="(item_, i) in item.startStopList"
                :key="item_.signalNo"
                class="emission-fog-top"
              >
                <div class="emission-chart-top">
                  <img class="title-img" src="../img/icon_gear_default.png" />
                  <span class="equipType">治理设备-</span>
                  <span class="label"
                    >{{
                      item.deviceName + "(" + item_.signalNo + ")"
                    }}-启停信号</span
                  >
                </div>
                <div :id="'fog' + i" class="emission-chart-bottom"></div>
              </div>
              <div v-if="item.powerObj" class="emission-fog-bottom">
                <div class="emission-chart-top">
                  <img class="title-img" src="../img/icon_gear_default.png" />
                  <span class="equipType">治理设备-</span>
                  <span class="label"
                    >{{
                      item.deviceName + "(" + item.deviceNo + ")"
                    }}-运行信号</span
                  >
                </div>
                <div id="powerObj" class="emission-chart-bottom"></div>
              </div>
            </div>
          </div>
          <!-- 洗车机底部chart -->
          <div v-else class="emission-wash">
            <!-- 洗车机 -->
            <div
              :id="'vehiclesChart-' + i"
              v-for="(item, i) in warns"
              :key="i"
              class="emission-wash-left"
            ></div>
            <div
              :id="'warnsChart-' + i"
              v-for="(item, i) in vehicles"
              :key="i"
              class="emission-wash-right"
            ></div>
          </div>
        </div>
      </div>
      <div class="return-btn" @click="returnFunc()">
        <span></span>
      </div>
    </div>
    <!-- 图片放大 -->
    <vdm-largeImg
      @bigImg="bigImg"
      :imgSrc="url"
      :imgLarge="imgLarge"
    ></vdm-largeImg>
  </div>
</template>

<script>
function getWarnOpt(pmData, that, n) {
  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  let y2Data = pmData.y2Data;
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "line",
        snap: true,
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "rgba(47,128,237, 0.05)", // 0% 处的颜色
              },
              {
                offset: 0.4,
                color: "rgba(86,204,242, 0.25)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(86,204,242, 0.45)", // 100% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(255, 0, 255, 0)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(4, 0, 255, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          width: 400,
        },
      },
      backgroundColor: "#000",
      padding: 10,
      textStyle: {
        color: "#fff",
      },
      formatter: function (params) {
        let res;
        if (params[0]) {
          try {
            res = `<span>时间: ${params[0].axisValue}</span></br>`;
            res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${"违规地点"}: ${
              params[0].value[2].position
            } </span></br><span>${"违规车辆"}: ${
              params[0].value[2].deviceNo
            } </span></br><span>${"违规描述"}: ${
              params[0].value[2].describe
            } </span></br><span>${"处理结果"}: ${
              params[0].value[2].result
            } </span></br>`;
          } catch {}
        }
        for (var i = 1; i < params.length; i++) {
          if (params[i]) {
            try {
              if (params[i].value[2].isWarning == 0) {
                // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
              } else if (params[i].value[2].isWarning == 1) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${params[i].seriesName}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${params[i].value[2].happenTime}</br>&nbsp;&nbsp;&nbsp;&nbsp;洗车水压：${params[i].value[2].vdmTdc} kpa</span></br>&nbsp;&nbsp;&nbsp;&nbsp;车牌号：${params[i].value[2].car_name} </span></br>&nbsp;&nbsp;&nbsp;&nbsp;洗车时长：${params[i].value[2].runTimeValue} </span></br>`;
              }
            } catch {}
          }
        }
        return res;
      },
    },
    legend: {
      icon: "circle",
      left: "40%",
      top: "8%",
      data: [{ name: "洗车水压 ", icon: "circle" }],
      formatter: function (name) {
        return name;
      },
      itemWidth: 20,
      itemHeight: 20,
      textStyle: {
        fontSize: 14,
        color: "rgba(255,255,255,0.6)",
        padding: [2, 0, 0, 0],
      },
      selectedMode: false,
    },
    grid: {
      top: "25%",
      left: "5%",
      right: "6%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          lineStyle: {
            color: "grey",
            width: 0.1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          textStyle: {
            color: "#b1b6b7",
            fontSize: 12,
            margin: 15,
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    yAxis: [
      {
        name: "单位：次",
        nameTextStyle: {
          fontSize: 14,
          color: "#A6CAFF",
          padding: [0, 0, 0, 20],
        },
        max: 2,
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            color: "#b1b6b7",
            fontSize: 12,
          },
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "洗车水压",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 25,
        itemStyle: {
          color: function (value) {
            if (value.value[2].isWarning == 0) {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                ],
                false
              );
              return v;
            } else {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                ],
                false
              );
              return v;
            }
          },
        },
        data: y2Data,
      },
    ],
  };
}
function getVehicleOpt(pmData, that, n) {
  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  let y2Data = pmData.y2Data;
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "line",
        snap: true,
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "rgba(47,128,237, 0.05)", // 0% 处的颜色
              },
              {
                offset: 0.4,
                color: "rgba(86,204,242, 0.25)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(86,204,242, 0.45)", // 100% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(255, 0, 255, 0)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(4, 0, 255, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          width: 400,
        },
      },
      backgroundColor: "#000",
      padding: 10,
      textStyle: {
        color: "#fff",
      },
      formatter: function (params) {
        let res;
        if (params[0]) {
          try {
            res = `<span>时间: ${params[0].axisValue}</span></br>`;
            res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${"洗车水压"}: ${
              params[0].value
            } kpa</span></br>`;
          } catch {}
        }
        for (var i = 1; i < params.length; i++) {
          if (params[i]) {
            try {
              if (params[i].value[2].isWarning == 0) {
                // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
              } else if (params[i].value[2].isWarning == 1) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${params[i].seriesName}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${params[i].value[2].happenTime}</br>&nbsp;&nbsp;&nbsp;&nbsp;洗车水压：${params[i].value[2].vdmTdc} kpa</span></br>&nbsp;&nbsp;&nbsp;&nbsp;车牌号：${params[i].value[2].car_name} </span></br>&nbsp;&nbsp;&nbsp;&nbsp;洗车时长：${params[i].value[2].runTimeValue} </span></br>`;
              }
            } catch {}
          }
        }
        return res;
      },
    },
    legend: {
      icon: "circle",
      left: "40%",
      top: "8%",
      data: [{ name: "洗车水压 ", icon: "circle" }],
      formatter: function (name) {
        return name;
      },
      itemWidth: 20,
      itemHeight: 20,
      textStyle: {
        fontSize: 14,
        color: "rgba(255,255,255,0.6)",
        padding: [2, 0, 0, 0],
      },
      selectedMode: false,
    },
    grid: {
      top: "25%",
      left: "5%",
      right: "6%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          lineStyle: {
            color: "grey",
            width: 0.1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          textStyle: {
            color: "#b1b6b7",
            fontSize: 12,
            margin: 15,
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    yAxis: [
      {
        name: "单位：kPa",
        nameTextStyle: {
          fontSize: 14,
          color: "#A6CAFF",
          padding: [0, 0, 0, 20],
        },
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#1E5389",
            width: 1,
          },
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            color: "#b1b6b7",
            fontSize: 12,
          },
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "小时监测",
        type: "line",
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          normal: {
            width: 3,
            color: "#00FFFF",
          },
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.RadialGradient(
              0.5,
              0.5,
              0.5,
              [
                {
                  offset: 0,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 255, 255, 0.5)",
                },
              ],
              false
            ),
          },
        },
        data: y1Data,
      },
      {
        name: "洗车水压",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 25,
        itemStyle: {
          color: function (value) {
            if (value.value[2].isWarning == 0) {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                ],
                false
              );
              return v;
            } else {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                ],
                false
              );
              return v;
            }
          },
        },
        data: y2Data,
      },
    ],
  };
}
import { unref, computed, nextTick } from "vue";
import moment from "moment";
import getVdmOpt from "./chart/vdmChart.js";
import getOption from "./chart/fogChart.js";
import { getOption_ } from "./chart/fogChart_.js";
import { unwarp, getOpt } from "@/utils/tools.js";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import vdmLargeImg from "./vdmLargeImg.vue";
import vdmCvr from "@/modules/videoComponents/component/vdmCvr.vue";
import easyCvr from "@/modules/videoComponents/component/easyCvr.vue";
import chartBarFog from "@/modules/Charts/chartBarFog";
import { DatePicker } from "@/modules/commonDatePicker";
import { setPageActive } from "@/utils/platformmonitor.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    vdmLargeImg,
    vdmCvr,
    easyCvr,
    chartBarFog,
    DatePicker
  },
  props: ["detailPopup"],
  data() {
    //这里存放数据
    return {
      recodeDate: "",
      curTime: '',
      nvrIp: "",
      channelId: '',
      dateRange: [
        moment(new Date() - 24 * 3600 * 1000).format("YYYY-MM-DD HH:mm:ss"),
        moment().format("YYYY-MM-DD HH:mm:ss"),
      ],
      imgLarge: false,
      chart: null,
      chartTimer: null,
      fogChart: null,
      fogPwrChart: null,
      materialObj: {},
      form: {},
      lastVdm: {},
      url: "",
      vdmImgList: [],
      dusters: [],
      vehicles: [],
      warns: [],
      warnsChart: [],
      warnImg: [],
      vehiclesImg: [],
      warnsOptions: [],
      vehiclesOptions: [],
      vehiclesChart: [],
    };
  },
  //监控data中的数据变化
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.reset();
    setPageActive("网格化料场管理功能","open",true);
  },
  //方法集合
  methods: {
    changeTime(time) {
      this.dateRange = time;
    },
    returnFunc() {
      this.$emit("closeVdm");
    },
    // 放大图片 事件委托
    largeImg(event) {
      if (event.target.nodeName.toLowerCase() === "img") {
        const index = parseInt(event.target.getAttribute("data-index"));
        if (index !== -1) this.url = this.vdmImgList[index].imgUrl;
        this.imgLarge = true;
      }
    },
    bigImg() {
      this.imgLarge = false;
    },
    async search() {
      if (this.detailPopup.deviceType !== "洗车台") {
        // let url = CONFIG.requestName + this.$apiOpt.findDeviceDetail;
        let url = "http://screen.bmetech.com/screen" + this.$apiOpt.findDeviceDetail;
        try {
          let res = await this.$apiUtils.get(url, {
            // customerId: this.$store.state.customerId,
            customerId: 38,
            // deviceNo: this.detailPopup.deviceNo,
            deviceNo: this.detailPopup.deviceType !== '雾炮' ? 'BMEVDM0A210423008' : 'YG_ZL_WP_01',
            type: this.detailPopup.deviceType === "雾炮" ? 2 : 1,
            // signalNo: this.detailPopup.signalNo,
            signalNo: this.detailPopup.deviceType !== '雾炮' ?  'BMEVDM0A210423008_263' : 'YG_ZL_WP_01_1',
            startTime: this.dateRange[0],
            endTime: this.dateRange[1],
          });
          if (this.detailPopup.deviceType === "雾炮") {
            if (res.dusters.length) {
              let dusters = [];
              res.dusters.forEach((r) => dusters.push(r));
              this.dusters = this.disposeFogList(dusters, "雾炮");
              this.$nextTick(() => this.drawChart(this.dusters));
            }
          } else {
            if (res.shedVdmVideo) {
              const { diskIpAddress, videoChannel } = res.shedVdmVideo;
              this.nvrIp = diskIpAddress;
              this.channelId = videoChannel;
            }
            const { vdmImgList, signalDetailList, unit } = res.vdms[0];
            if (vdmImgList && vdmImgList.length) {
              let list = vdmImgList.sort((a, b) => {
                return (
                  new Date(a.collectionTime).getTime() -
                  new Date(b.collectionTime).getTime()
                );
              });
              this.vdmImgList = list;
              console.log(this.vdmImgList, 'vdmImgList')
              this.disposeVdmImgList(this.vdmImgList);
              this.curTime = this.vdmImgList[this.vdmImgList.length - 1]['collectionTime'];
            }
            if (unit) this.unitType = unit;
            if (signalDetailList && signalDetailList.length) {
              this.disposeVdmList(signalDetailList);
            }
          }
        } catch (err) {
          console.error(err);
        }
        this.chartTimer = setTimeout(() => {
          if (this.vdmImgList.length && this.$refs.carousel)
            this.$refs.carousel.setActiveItem(this.vdmImgList.length - 1);
        }, 500);
      } else {
        let that = this;
        this.getWashCarHistory();
      }
    },
    async reset() {
      this.dateRange = [
        moment(new Date() - 24 * 3600 * 1000).format("YYYY-MM-DD HH:mm:ss"),
        moment().format("YYYY-MM-DD HH:mm:ss"),
      ];
      this.search();
    },
    disposeVdmList(list) {
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      this.pmData = pmData;
      list.sort((a, b) => {
        return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
      });
      list.forEach((item) => {
        pmData.xData.push(item.dateTime);
        pmData.y1Data.push(item.value);
      });
      this.vdmImgList.forEach((m) => {
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (
              new Date(collectionTime).getTime() >
              new Date(pmDataList[i]).getTime()
            ) {
              if (
                new Date(collectionTime).getTime() <
                new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.value);
              }
            }
          }
        }
      });
      this.vdmImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.value || 0,
          {
            isWarning: v.isAlarm ? "1" : "0",
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
          },
        ];
        pmData.y2Data.push(arr);
      });
      this.$nextTick(() => {
        this.chart = echarts.init(this.$refs.Echart);
        let options = getVdmOpt(pmData, this);
        this.chart.resize();
        unwarp(this.chart).setOption(options, false);
        this.chart.on("click", (param) => {
          const { data } = param;
          let tmp = data[0];
          this.recodeDate = tmp;
          let index = this.vdmImgList.findIndex(
            (item) => item.collectionTime === tmp
          );
          if (index !== -1) {
            if (this.$refs.carousel) this.$refs.carousel.setActiveItem(index);
            this.lastVdm = this.vdmImgList[index];
          }
        });
      });
    },
    disposeFogList(list, typeName) {
      let that = this;
      list.forEach((item) => {
        let dusterDetail = item.dusterDetail;
        item.startStopList = [];
        item.otherList = [];
        item.powerObj = {};
        item.deviceName = typeName;
        let dustDeviceName = typeName;
        let dustDeviceNo = item.deviceNo;

        dusterDetail.forEach((item_) => {
          let dataList = item_.list;
          let signalName = item_.signalName;
          let type = item_.type;
          if (signalName === "运行信号" || type === "1") {
            let xdata = [],
              ydata = [[], [], []];
            dataList.forEach(({ dateTime, time, value }) => {
              xdata.push(
                time != null
                  ? time
                  : that.$moment(dateTime).format("YYYY-MM-DD HH:mm")
              );
              ydata[0].push({ value: 1 }); //用于离线
              ydata[1].push({ value: value != 0 ? 1 : 0 }); //启 会被暂无数据遮住
              if (value === null) {
                ydata[2].push({ value: 1 }); //用于显示暂无数据
              } else {
                ydata[2].push({ value: 0 });
              }
            });
            let options = {
              tooltip: {
                formatter(params) {
                  let str = "";
                  str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
                  if (params[0].value && params[2].value) {
                    //无 (启 会被暂无数据遮住)
                    str += `<div>时间：${params[0].name}</div>`;
                    str += `<div>启停信号：${params[2].seriesName}</div>`;
                  } else if (params[0].value && !params[2].value) {
                    //开
                    str += `<div>时间：${params[0].name}</div>`;
                    str += `<div>启停信号：${params[0].seriesName}</div>`;
                  } else {
                    //停
                    str += `<div>时间：${params[1].name}</div>`;
                    str += `<div>启停信号：${params[1].seriesName}</div>`;
                  }
                  str += `</div>`;
                  //		params.forEach((item,i)=>{
                  //			if()
                  //			str+=`<div class="tooltip" style="font-size:30px;line-height:40px;">${item.name}：${item.value}</div>`
                  //		})
                  return str;
                },
              },
              xdata,
              ydata,
              signalName,
              themeName: "govern",
              deviceNo: dustDeviceNo,
            };
            item.startStopList.push({
              signalName: item_.signalName,
              signalNo: item_.signalNo,
              options: options,
            });
          } else {
            item.otherList.push(item_);
          }
        });

        let xdata = [];
        let lineYdata = [];
        let toolTipLine = {
          formatter(params) {
            let str = "";
            str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
            str += `<div>时间：${params[0].name}</div>`;
            params.forEach((item) => {
              let value =
                item.value === "" || item.value === undefined
                  ? "暂无数据"
                  : item.value;
              let unit = item.value === "" ? "" : item.data.unit;
              str += `<div>
								${item.seriesName}：${value}${unit}
							</div>`;
            });
            str += `</div>`;
            return str;
          },
        };
        let xAxis = {
          axisLabel: {
            align: "left",
            color: "#A6CAFF",
            fontSize: 18,
            //interval: xdata.length / 8,
          },
        };
        let grid = {
          left: "5%",
          right: "5%",
        };
        item.otherList.forEach((item_, n) => {
          let tmpList = item_.list;
          let unit = item_.unit;
          if (n === 0) {
            tmpList.forEach((x, i) => {
              xdata.push(
                x.time != null
                  ? x.time
                  : that.$moment(x.dateTime).format("MM-DD HH:mm")
              );
            });
          }
          let sData = { name: item_.signalName, data: [] };
          tmpList.forEach((x, i) => {
            //						xdata.push(x.time);
            if (x.value === null) {
              x.value = "";
            }
            let sObj = { value: x.value, unit: unit };
            sData.data.push(sObj);
          });
          lineYdata.push(sData);
        });
        let options = {
          dustDeviceName,
          dustDeviceNo,
          name: dustDeviceName,
          lineOptions: {
            name: dustDeviceName,
            tooltip: toolTipLine,
            xAxis,
            grid,
            xdata,
            ydata: lineYdata,
            themeName: "governPower",
          },
        };
        if (xdata.length > 0 && lineYdata.length > 0) {
          item.powerObj = options;
        } else {
          item.powerObj = "";
        }
      });
      return list;
    },
    disposeVdmImgList(list) {
      if (list && list.length) {
        this.lastVdm = list[list.length - 1];
      }
    },
    drawChart(list) {
      list.forEach((item) => {
        item.startStopList.forEach((item_, i) => {
          if (this.fogChart) {
            this.fogChart = null;
          }
          this.fogChart = echarts.init(document.getElementById("fog" + i));
          let { xdata, ydata, ...otherParam } = unwarp(item_.options);
          let opt = getOption(xdata, ydata, otherParam);
          unwarp(this.fogChart).setOption(opt);
        });
        if (item.powerObj) {
          if (this.fogPwrChart) {
            this.fogPwrChart = null;
          }
          this.fogPwrChart = echarts.init(document.getElementById("powerObj"));
          let { xdata, ydata, ...otherParam } = unwarp(
            item.powerObj.lineOptions
          );
          let opt = getOption_(xdata, ydata, otherParam);
          unwarp(this.fogPwrChart).setOption(opt);
        }
      });
    },
    getWashCarHistory() {
      let that = this;
      let washCarId = this.detailPopup.deviceNo;
      this.getWashCarInfo(washCarId, (res) => {
        let records =
          res["page"] && res["page"]["records"] ? res["page"]["records"] : [];
        records = records.sort((a, b) => {
          return (
            new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
          );
        });
        let vdmsVehicles = [];
        let vdmsVehicleObj = {
          signalDetailList: [],
          vdmImgList: [],
          deviceName: "",
        };
        records.forEach((item) => {
          vdmsVehicleObj.vdmImgList.push({
            collectionTime: item.startTime,
            createTime: item.startTime,
            runTime: item.runTimeValue,
            deviceNo: item.car_name,
            id: item.id,
            imgUrl: item.pic_url,
            isAlarm: false,
            signalNo: item.device_no,
            value: item.pressure.replace("kPa", ""),
          });

          vdmsVehicleObj.deviceName = item.device_no;
        });
        for (let i = 0; i < 24; i++) {
          let hour = i < 10 ? "0" + i : i;
          vdmsVehicleObj.signalDetailList.push({
            dateTime: this.$moment().format("YYYY-MM-DD " + hour + ":00:00"),
            value: 0,
          });
        }
        vdmsVehicles.push(vdmsVehicleObj);
        that.getWarnInfo(washCarId, (res_) => {
          let warnRecords = res_["records"] ? res_["records"] : [];
          warnRecords = warnRecords.sort((a, b) => {
            return (
              new Date(a.createTime).getTime() -
              new Date(b.createTime).getTime()
            );
          });
          let vdmsWarn = [];
          let vdmsWarnObj = {
            signalDetailList: [],
            vdmImgList: [],
            deviceName: "",
          };
          warnRecords.forEach((item) => {
            vdmsWarnObj.vdmImgList.push({
              collectionTime: item.createTime,
              createTime: item.createTime,
              runTime: item.runTimeValue,
              deviceName: item.deviceName,
              deviceNo: item.deviceNo,
              position: item.position,
              id: item.id,
              imgUrl: item.fileName,
              isAlarm: true,
              result: item.result,
              describe: item.describe,
              value: 1,
            });

            vdmsWarnObj.deviceName = item.deviceName;
          });
          for (let i = 0; i < 24; i++) {
            let hour = i < 10 ? "0" + i : i;
            vdmsWarnObj.signalDetailList.push({
              dateTime: this.$moment().format("YYYY-MM-DD " + hour + ":00:00"),
              value: undefined,
            });
          }
          vdmsWarn.push(vdmsWarnObj);
          that.vehicles = vdmsVehicles;
          that.warns = vdmsWarn;
          console.log(vdmsWarn, "vdmsWarn");
          that.$nextTick(function () {
            that.vehicles.forEach((item, n) => {
              that.vehicleHistoricalOperation(item, n);
            });

            that.warns.forEach((item, n) => {
              that.warnHistoricalOperation(item, n);
            });
          });
        });
      });
    },
    getWashCarInfo(washCarId, cb) {
      let getCarWashProcessInfoUrl =
        CONFIG.requestName + this.$apiOpt.getCarWashProcessInfo;
      this.$apiUtils
        .get(getCarWashProcessInfoUrl, {
          // customerId: this.$store.state.customerId,
          customerId: '38',
          // dtuNum: washCarId,
          dtuNum: 'YG_ZL_WP_02',
          // startTime: this.dateRange[0],
          startTime: this.$moment().format('YYYY-MM-DD 00:00:00'),
          // endTime: this.dateRange[1],
          endTime: this.$moment().format('YYYY-MM-DD 23:59:59'),
          pageNo: 1,
          pageSize: 1000,
        })
        .then((res) => {
          cb(res);
        });
    },
    getWarnInfo(washCarId, cb) {
      let getViolationNewUrl = CONFIG.requestName + this.$apiOpt.violationNew;
      this.$apiUtils
        .get(getViolationNewUrl, {
          // deviceNo: washCarId,
          deviceNo: 'YG_ZL_WP_02',
          triggerType: "",
          Postion: "",
          // startTime: this.dateRange[0],
          // endTime: this.dateRange[1],
          // customerId: this.$store.state.customerId,
          customerId: 38,
          startTime: this.$moment().format('YYYY-MM-DD 00:00:00'),
          endTime: this.$moment().format('YYYY-MM-DD 23:59:59'),
          pageNo: 1,
          pageSize: 1000,
        })
        .then((res) => {
          cb(res);
        });
    },
    vehicleHistoricalOperation(vehicleList, n) {

      let that = this;
      if (this.vehiclesChart[n]) {
        this.vehiclesChart[n] = null;
      }
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let imgList = [];
      let tmpImgList = vehicleList.vdmImgList.sort(function (a, b) {
        return (
          new Date(a.collectionTime).getTime() -
          new Date(b.collectionTime).getTime()
        );
      });
      tmpImgList.forEach((_) => {
        imgList.push(_.imgUrl);
      });
      this.vehiclesImg[n] = tmpImgList;
      let signalDetailList = vehicleList.signalDetailList.sort(function (a, b) {
        return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
      });

      signalDetailList.forEach((_) => {
        pmData.xData.push(_.dateTime);
        pmData.y1Data.push(_.value);
      });
      tmpImgList.forEach((m, n) => {
        m.tdc = m.value;
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (
              new Date(collectionTime).getTime() >
              new Date(pmDataList[i]).getTime()
            ) {
              if (
                new Date(collectionTime).getTime() <
                new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.tdc);
              }
            }
          }
        }
      });
      tmpImgList.forEach((item, i) => {
        for (var x = 0; x < pmData.xData.length; x++) {
          if (item.collectionTime == pmData.xData[x]) {
            item.index = x;
            break;
          }
        }
      });
      tmpImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.tdc || 0,
          {
            isWarning: v.isAlarm ? "1" : "0",
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
            car_name: v.deviceNo,
            runTimeValue: v.runTime,
          },
        ];
        pmData.y2Data.push(arr);
      });
      this.$nextTick(() => {
        if (that.vehiclesChart[n]) {
          that.vehiclesChart[n] = null;
        }

        that.vehiclesChart[n] = echarts.init(
          document.getElementById("vehiclesChart-" + n)
        );
        that.vehiclesOptions[n] = getVehicleOpt(pmData, that, n);
        unwarp(that.vehiclesChart[n]).setOption(that.vehiclesOptions[n]);
        console.log(that.$refs, 'warn')
        if(that.vehiclesImg.length) {
          that.vehicles.forEach((item, i) => {
            that.$refs.wash0[i].setActiveItem(that.vehiclesImg.length -1);
          })
        } else {
          that.vehicles.forEach((item, i) => {
            that.$refs.wash0[i].setActiveItem(0);
          })
        }
      });
    },
    warnHistoricalOperation(warnList, n) {
      console.log(warnList, "vehiclesOptions");
      let that = this;
      if (this.warnsChart[n]) {
        this.warnsChart[n] = null;
      }
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let imgList = [];
      let tmpImgList = warnList.vdmImgList.sort(function (a, b) {
        return (
          new Date(a.collectionTime).getTime() -
          new Date(b.collectionTime).getTime()
        );
      });
      this.warnImg[n] = tmpImgList;
      let signalDetailList = warnList.signalDetailList.sort(function (a, b) {
        return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
      });

      signalDetailList.forEach((_) => {
        pmData.xData.push(_.dateTime);
        pmData.y1Data.push(_.value);
      });
      tmpImgList.forEach((m, n) => {
        m.tdc = m.value;
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (
              new Date(collectionTime).getTime() >
              new Date(pmDataList[i]).getTime()
            ) {
              if (
                new Date(collectionTime).getTime() <
                new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.tdc);
              }
            }
          }
        }
      });
      tmpImgList.forEach((item, i) => {
        for (var x = 0; x < pmData.xData.length; x++) {
          if (item.collectionTime == pmData.xData[x]) {
            item.index = x;
            break;
          }
        }
      });
      tmpImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.tdc || 0,
          {
            isWarning: v.isAlarm ? "1" : "0",
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
            position: v.position,
            deviceNo: v.deviceNo,
            describe: v.describe,
            result: v.result,
          },
        ];
        pmData.y2Data.push(arr);
      });
      this.$nextTick(() => {
        if (that.warnsChart[n]) {
          that.warnsChart[n] = null;
        }
        that.warnsChart[n] = echarts.init(
          document.getElementById("warnsChart-" + n)
        );
        that.warnsOptions[n] = getWarnOpt(pmData, that, n);
        unwarp(that.warnsChart[n]).setOption(that.warnsOptions[n]);
        if(that.warnImg.length) {
          that.warns.forEach((item, i) => {
            that.$refs.warn0[i].setActiveItem(that.warnImg.length - 1)
          });
        }else {
          that.warns.forEach((item, i) => {
            that.$refs.warn0[i].setActiveItem(0);
          });
        }
      });
    },
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
    if (this.fogChart) {
      this.fogChart.dispose();
      this.fogChart = null;
    }
    if (this.fogPwrChart) {
      this.fogPwrChart.dispose();
      this.fogPwrChart = null;
    }
    if (this.chartTimer) {
      clearTimeout(this.chartTimer);
    }
    if(this.warnsChart.length) {
      this.warnsChart.forEach((w, i) => {
        this.warnsChart[i].dispose();
        this.warnsChart[i] = null;
      });
    }
    if(this.vehiclesChart.length) {
      this.vehiclesChart.forEach((w, i) => {
        this.vehiclesChart[i].dispose();
        this.vehiclesChart[i] = null;
      });
    }
    Object.assign(this.$data, this.$options.data());
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
.bringins-content {
  position: absolute !important;
  z-index: 99999999 !important;
}
.padding-class {
  padding-top: 180px !important;
}
.emission {
  &-content {
    padding-top: 80px;
    overflow: auto;
  }
  &-title {
    position: absolute;
    top: 35px;
    left: 50%;
    transform: translateX(-50%);
    margin: auto;
    font-size: 30px;
    color: yellow;
    border-bottom: 1px solid #000;
  }
  &-top {
    display: flex;
    height: 100px;
    > div {
      text-align: center;
      flex: 1;
      line-height: 100px;
      font-size: 30px;
    }
    .label {
      margin-right: 50px;
    }
  }
  &-middle {
    display: flex;
    height: 350px;
    justify-content: center;
  }
  &-bottom {
    height: 400px;
  }
  &-wash {
    height: 300px;
    display: flex;
    margin-top: 20px;
    &-left {
      margin-right: 20px;
    }
    &-left,
    &-right {
      flex: 1;
      height: 300px;
      background-color: #000;
    }
  }
  &-left {
    display: flex;
    margin-right: 20px;
    background: #000;
    width: 50%;
  }
  &-right {
    display: flex;
    background: #000;
    width: 50%;
  }
  &-date {
    position: relative;
    height: 100px;
    > span {
      position: absolute;
      top: 30px;
      font-size: 25px;
    }
  }
  &-chart {
    width: 100% !important;
    height: calc(100% - 100px) !important;
    background: #000;
  }
  &-fog {
    &-top {
      width: 100%;
      height: 300px;
      background-color: #000;
    }
    &-bottom {
      width: 100%;
      height: 300px;
      background: #000;
    }
  }
  &-chart {
    &-top {
      height: 100px;
      line-height: 100px;
      .label {
        font-size: 25px;
      }
    }
    &-bottom {
      height: calc(100% - 100px);
    }
  }
}
:deep(.el-carousel__indicator--horizontal) {
  display: none;
}
:deep(.el-image) {
  cursor: pointer;
}
:deep(.el-form) {
  position: absolute;
  right: 20px;
}
.title {
  height: 100%;
  color: yellow;
  line-height: 100px;
  font-size: 30px;
  writing-mode: vertical-lr;
  text-align: center;
}
.content {
  flex: 1;
}
</style>
